import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MovieCreationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"movie_creation"}/>
}
